import { DemoIds, IDemo } from 'types'

import { getSharedAsset } from '../utils'

const video = getSharedAsset('taqtile.mp4', 'sessions', 'videos')
const poster = getSharedAsset('taqtile.png', 'sessions', 'posters')
const monolith = getSharedAsset('taqtile.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('mec-explainer.png', 'demos', 'thumbnails')

export const taqtile: IDemo = {
  id: DemoIds.taqtile,
  video,
  monolith,
  poster,
  end: {
    header: 'Immersive 5G AR/VR training.',
    body: `Pairing Verizon's 5G technology with Taqtile’s Manifest solution could provide frontline troops the ability to conduct operational enablement and training on real world equipment.`,
    nextDemoText: 'Harness the cloud.',
    nextDemoId: DemoIds.mecExplainer,
    nextDemoThumbnail,
    previousDemoId: DemoIds.vuzix
  }
}
